import 'leaflet-easyprint';
import 'leaflet-measure/dist/leaflet-measure.fr';
import 'leaflet-fullscreen/dist/Leaflet.fullscreen.min';
import Dap from './massia-dap.model';

export default class DapValidateFormController {
	/* @ngInject */
	constructor(
		$scope,
		$timeout,
		$state,
		$stateParams,
		DAPsCommunicationService,
		DAPsService,
		DocumentsService,
		RouterHistoryService,
		ChantiersService,
		notification,
		$location,
		$anchorScroll,
		$translate,
		$uibModal,
		moment,
		ModalService,
		PersonnesService,
		NomenclaturesService,
		SettingPortailService
	) {
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$state = $state;
		this.$stateParams = $stateParams;
		this.DAPsCommunicationService = DAPsCommunicationService;
		this.DAPsService = DAPsService;
		this.DocumentsService = DocumentsService;
		this.chantierService = ChantiersService;
		this.historyService = RouterHistoryService;
		this.notification = notification;
		this.$location = $location;
		this.$anchorScroll = $anchorScroll;
		this.$translate = $translate;
		this.$uibModal = $uibModal;
		this.moment = moment;
		this.ModalService = ModalService;
		this.PersonnesService = PersonnesService;
		this.NomenclaturesService = NomenclaturesService;
		this.SettingPortailService = SettingPortailService;
		this.currDap = null;
		this.loading = false;
		this.isOpenForm = true;
		this.map = {};
		this.haveCreation = false;

		/* Listes  MultiSelect*/
		this.chantiers = [];
		this.transporteurs = [];
		this.producteurs = [];
		this.demandeurs = [];
		this.siteCommerciaux = [];
		this.dechets = [];
		this.ecoOrganismes = [];
		this.lieux = [];

		this.loading = true;
		this.isChantierCreated = false;
		this.oldChantier = {};
		this.untouchedDap = {};
		this.isProducteurDemandeur = true;
		this.id = null;
		this.isEditMode = false;
		this.tmp = {
			chantier: [],
			ecoOrganisme: [],
			lieu: {}
		};

		this.estCodeAuto = false;

		this.mapController = null;
		this.fromExternalForm = false;
	}

	async $onInit() {
		this.isOpen = true;
		this.loading = true;
		if (this.$stateParams.id) {
			this.id = this.$stateParams.id;
			try {
				const dapData = await this.DAPsService.getDapEnteteById(this.id);
				// console.log(dapData);
				this.currDap = new Dap(dapData);
				if (this.currDap.producteur && this.currDap.producteur.id) {
					this.isProducteurDemandeur = false;
				}
			} catch (error) {
				console.error('Error fetching Dap data:', error);
			}
			this.isEditMode = true;
		} else {
			this.currDap = this.historyService?.dap || new Dap(); //this.historyService?.dap est utilisé pour les "aller/retour" formulaire
			let d = new Date(),
				date = d.toLocaleDateString('fr-FR'),
				nextYear = new Date(d.setFullYear(d.getFullYear() + 1)).toLocaleDateString('fr-FR');

			this.currDap.dateDebutValidite = date;
			this.currDap.dateValidite = nextYear;

			if (this.historyService?.dap && this.currDap.producteur && this.currDap.producteur.id) {
				this.isProducteurDemandeur = false;
			}
		}

		this.estCodeAuto = await this.DAPsService.estCodeAuto();

		if (this.currDap.lieu && this.currDap.lieu.fullAdresse) {
			this.currDap.lieu.adresse = this.currDap.lieu.fullAdresse.adresse;
			this.currDap.lieu.codePostal = this.currDap.lieu.fullAdresse.codePostal;
			this.currDap.lieu.ville = this.currDap.lieu.fullAdresse.ville;
		}
		if (this.currDap.chantier && this.currDap.chantier.fullAdresse) {
			this.currDap.chantier.adresse = this.currDap.chantier.fullAdresse.adresse;
			this.currDap.chantier.codePostal = this.currDap.chantier.fullAdresse.codePostal;
			this.currDap.chantier.ville = this.currDap.chantier.fullAdresse.ville;
		}

		this.currDap.estCodeAuto = this.estCodeAuto;
		this.currDapEtat = this.currDap.etat == 1 ? true : false;
		await this.initialGet();
		this.updateCoordGeo();
		this.loading = false;
		this.getSignatureStates();

		this.dapDocSetting = await this.SettingPortailService.getDocSetting('DAP');
		if (this.dapDocSetting && this.dapDocSetting.data) {
			this.portailAcces = this.dapDocSetting.data.envoiAuto;
		}
	}

	$onDestroy() {
		if (!this.fromExternalForm) {
			delete this.historyService.dap;
		}
	}

	setMapController(controller) {
		this.mapController = controller;
		setTimeout(() => {
			if (this.mapController && this.currDap.chantier && this.currDap.chantier.coordGeo) {
				this.mapController.updateMarker(this.currDap.chantier.coordGeo.latitude, this.currDap.chantier.coordGeo.longitude);
			}
		}, 50);
	}

	async getControles() {
		try {
			this.controles = await this.DAPsService.getControles();
			this.controles = this.controles.items;
			if (this.currDap && this.currDap.controles) {
				this.controles.forEach((item) => {
					const index = this.currDap.controles.findIndex((element) => element.id == item.id);
					if (index !== -1) {
						item.selected = true;
					}
				});
			}
		} catch (ex) {
			this.notification.error(ex.data);
		}
	}

	async getSiteCommerciaux() {
		try {
			this.siteCommerciaux = await this.DAPsService.getSiteCommerciaux();
		} catch (ex) {
			this.notification.error(ex.data);
		}
	}

	async getSiteProducteurs() {
		if (this.currDap && this.currDap.siteAccueil && this.currDap.siteAccueil.id) {
			try {
				this.siteProducteurs = await this.DAPsService.getProducteurs('null', this.currDap.siteAccueil.id);
			} catch (ex) {
				this.notification.error(ex.data);
			}
		} else {
			this.siteProducteurs = [];
		}
	}

	async getDemandeurs() {
		if (this.currDap.siteAccueil && this.currDap.siteAccueil.idSociete) {
			try {
				this.demandeurs = await this.DAPsService.getFiltreClients(this.currDap.siteAccueil.idSociete);
			} catch (ex) {
				this.notification.error(ex.data);
			}
		} else {
			this.demandeurs = [];
		}
	}

	async getDechets() {
		this.dechets = await this.DAPsService.getNomenclatures();
	}

	async saveSelectedDechets(dechet) {
		const index = this.dechets.findIndex((d) => d.id == dechet.id);
		if (index != -1) {
			this.dechets[index].selected = dechet.selected;
		}
		if (dechet.selected) {
			dechet.isDangereux = this.dechets.find((d) => d.id == dechet.id).isDangereux;
			this.currDap.dechets.push(dechet);
		} else {
			this.currDap.dechets = this.currDap.dechets.filter((x) => x.id !== dechet.id);
		}
	}

	async saveSelectedDechetsAll() {
		this.dechets.map((x) => (x.selected = true));
		this.currDap.dechets = this.tmp.dechets;
	}

	async saveSelectedDechetsNone() {
		this.dechets.map((x) => (x.selected = false));
		this.currDap.dechets = [];
		this.tmp.dechets = [];
	}

	async getProducteurs() {
		try {
			if (this.currDap.demandeur && this.currDap.demandeur.id)
				this.producteurs = await this.DAPsService.getProducteursBySite(this.currDap.demandeur.id);
			else this.producteurs = [];
		} catch (error) {
			console.log(error);
		}
	}

	async saveSelectedProducteur(producteur) {
		if (producteur != null && (this.currDap.producteur === null || producteur.id !== this.currDap.producteur.id)) {
			this.currDap.producteur = producteur;
		} else {
			this.currDap.producteur = null;
			this.producteurs.map((x) => {
				if (producteur == null || x.id === producteur.id) {
					x.selected = false;
					return x;
				}
			});
			this.currDap.isSignatureProducteurDechet = false;
		}
		this.getSignatureStates();
	}

	async saveSelectedSiteProducteur(siteProducteur) {
		if (siteProducteur != null && (this.currDap.siteProducteur === null || siteProducteur.id !== this.currDap.siteProducteur.id)) {
			this.currDap.siteProducteur = siteProducteur;
		} else {
			this.currDap.siteProducteur = null;
			this.siteProducteurs.map((x) => {
				if (siteProducteur == null || x.id === siteProducteur.id) {
					x.selected = false;
					return x;
				}
			});
		}
	}

	async saveSelectedSiteAccueil(siteAccueil) {
		let newSociete = false;
		if (siteAccueil != null && (this.currDap.siteAccueil === null || siteAccueil.id !== this.currDap.siteAccueil.id)) {
			newSociete = this.currDap.siteAccueil == null || siteAccueil.idSociete != this.currDap.siteAccueil.idSociete;
			this.currDap.siteAccueil = siteAccueil;
		} else {
			this.currDap.siteAccueil = null;
			newSociete = true;
			this.siteCommerciaux.map((x) => {
				if (siteAccueil == null || x.id === siteAccueil.id) {
					x.selected = false;
					return x;
				}
			});
		}
		if (newSociete) {
			this.currDap.demandeur = null;
			this.currDap.producteur = null;
			this.currDap.chantier = null;
			this.updateCoordGeo();

			await this.getFromSociete(true);
			if (this.currDap.siteProducteur != null && !this.siteProducteurs.some((prod) => prod.id == this.currDap.siteProducteur.id)) {
				this.currDap.siteProducteur = null;
			}
		}
	}

	async saveSelectedDemandeur(demandeur) {
		if (demandeur != null && (this.currDap.demandeur === null || demandeur.id !== this.currDap.demandeur.id)) {
			this.currDap.demandeur = demandeur;
		} else {
			this.currDap.demandeur = null;
			this.demandeurs.map((x) => {
				if (demandeur == null || x.id === demandeur.id) {
					x.selected = false;
					return x;
				}
			});
		}

		this.currDap.producteur = null;
		this.currDap.chantier = null;
		this.updateCoordGeo();
		await this.getFromDemandeur(true);
	}

	async getTransporteurs() {
		try {
			if (this.currDap.siteAccueil && this.currDap.siteAccueil.id)
				this.transporteurs = await this.DAPsService.getTransporteursBySite(this.currDap.siteAccueil.id);
			else this.transporteurs = [];
		} catch (error) {
			console.log(error);
		}
	}

	async saveSelectedTransporteurs(transporteur) {
		const index = this.transporteurs.findIndex((d) => d.id == transporteur.id);
		if (index != -1) this.transporteurs[index].selected = transporteur.selected;
		if (transporteur.selected) {
			this.currDap.transporteurs.push(transporteur);
		} else {
			this.currDap.transporteurs = this.currDap.transporteurs.filter((x) => x.id !== transporteur.id);
		}
		this.getSignatureStates();
	}

	async saveSelectedTransporteursAll() {
		this.transporteurs.map((x) => (x.selected = true));
		this.currDap.transporteurs = this.tmp.transporteurs;
	}

	async saveSelectedTransporteursNone() {
		this.transporteurs.map((x) => (x.selected = false));
		this.currDap.transporteurs = [];
		this.tmp.transporteurs = [];
	}

	async getEcoOrganismes() {
		this.ecoOrganismes = await this.DAPsService.getSocietesByType();
	}

	async saveSelectedEcoOrganisme() {
		this.currDap.ecoOrganisme = this.tmp.ecoOrganisme ? this.tmp.ecoOrganisme[0] : null;
	}

	async getChantier() {
		try {
			if (this.currDap.demandeur && this.currDap.demandeur.id)
				this.chantiers = await this.DAPsService.getChantiersByClientId(this.currDap.demandeur.id);
			else this.chantiers = [];
		} catch (error) {
			console.error(error);
		}
	}

	async saveSelectedChantier(chantier) {
		if (chantier != null && (this.currDap.chantier === null || chantier.id !== this.currDap.chantier.id)) {
			this.currDap.chantier = chantier;
			this.currDap.chantier.isChantierReferenceBasol = chantier.isReferenceBasol;
			this.currDap.chantier.isChantierReferenceBasias = chantier.isReferenceBasias;
		} else {
			this.currDap.chantier = null;
			this.chantiers.map((x) => {
				if (chantier == null || x.id === chantier.id) {
					x.selected = false;
					return x;
				}
			});
		}
		this.updateCoordGeo();
	}

	lieuCoordIsValid() {
		this.lieuIsValid = false;
		if (this.currDap.lieu && this.currDap.lieu.coordGeo && this.currDap.lieu.coordGeo.longitude && this.currDap.lieu.coordGeo.latitude) {
			this.lieuIsValid = true;
		}
		if (this.currDap.lieu && this.currDap.lieu.adresse && this.currDap.lieu.codePostal && this.currDap.lieu.ville) {
			this.lieuIsValid = true;
		}
		return this.lieuIsValid;
	}

	chantierCoordIsValid() {
		this.chantierIsValid = false;
		if (
			this.currDap.chantier &&
			this.currDap.chantier.coordGeo &&
			this.currDap.chantier.coordGeo.longitude &&
			this.currDap.chantier.coordGeo.latitude
		) {
			this.chantierIsValid = true;
		}
		if (this.currDap.chantier && this.currDap.chantier.adresse && this.currDap.chantier.codePostal && this.currDap.chantier.ville) {
			this.chantierIsValid = true;
		}
		return this.chantierIsValid;
	}

	updateCoordGeo() {
		if (this.lieuCoordIsValid()) {
			this.adresse = this.currDap.lieu.adresse;
			this.codePostal = this.currDap.lieu.codePostal;
			this.ville = this.currDap.lieu.ville;
			this.coordGeo = this.currDap.lieu.coordGeo;
		} else if (this.chantierCoordIsValid()) {
			this.adresse = this.currDap.chantier.adresse;
			this.codePostal = this.currDap.chantier.codePostal;
			this.ville = this.currDap.chantier.ville;
			this.coordGeo = this.currDap.chantier.coordGeo;
		} else {
			this.adresse = null;
			this.codePostal = null;
			this.ville = null;
			this.coordGeo = {};
		}
		if (this.coordGeo) {
			this.currDap.idCoordGeo = this.coordGeo.id;
		}
	}

	async getLieux() {
		const res = await this.DAPsService.getFullLieux();
		if (res) this.lieux = res.items;
	}

	async saveSelectedLieu() {
		this.currDap.lieu = this.tmp.lieu ? this.tmp.lieu[0] : null;
		this.updateCoordGeo();
	}

	async getFromDemandeur(load = false) {
		if (load) this.loading = true;
		await this.getChantier();
		await this.getProducteurs();
		if (load) this.loading = false;
	}

	async getFromSociete(load = false) {
		if (load) this.loading = true;
		await this.getSiteProducteurs();
		await this.getTransporteurs();
		await this.getDemandeurs();
		await this.getFromDemandeur();
		if (load) this.loading = false;
	}

	async initialGet(load = null) {
		if (load) this.loading = true;
		await this.getSiteCommerciaux();
		await this.getDechets();
		await this.getEcoOrganismes();
		await this.getLieux();
		await this.getControles();

		await this.getFromSociete();
		if (load) this.loading = false;
	}

	getContamination(chantier) {
		if (chantier == null) {
			return;
		}

		if (chantier.isContamine) {
			return 2;
		} else if (chantier.isPotentielContamine) {
			return 1;
		}

		return 0;
	}

	toDate(date) {
		const dateStr = date;
		const parts = dateStr.split('/');
		const dateObj = new Date(parts[2], parts[1] - 1, parts[0]);
		return dateObj;
	}

	onChangeProducteurDemandeur() {
		this.currDap.producteur = null;
		this.tmp.producteur = null;
		this.currDap.isSignatureProducteurDechet = false;
		this.getSignatureStates();
	}

	async createMassiaDap() {
		return await this.DAPsService.createMassiaDap(this.currDap);
	}

	async updateMassiaDap() {
		return await this.DAPsService.updateMassiaDap(this.currDap);
	}

	validate() {
		let res = true;
		console.log('VALIDATE', this.currDap.isValid(), this.isProducteurDemandeur, this.currDap.producteur);
		if (!this.currDap.isValid()) {
			this.notification.error(this.$translate.instant('DAPS.CHAMPS_OBLIGATOIRES'));
			res = false;
		}
		if (!this.isProducteurDemandeur && !this.currDap.producteur) {
			this.notification.error(this.$translate.instant('DAPS.CHAMPS_OBLIGATOIRES'));
			res = false;
		}

		return res;
	}

	changeEtat() {
		this.currDap.etat = this.currDapEtat ? 1 : 0;
	}

	async save() {
		this.loading = true;
		let id = 0;
		if (this.validate()) {
			//Permet de réappliquer les updates si non existant avant et calculé depuis l'adresse
			if (this.lieuCoordIsValid()) {
				this.currDap.lieu.coordGeo = this.coordGeo;
			} else if (this.chantierCoordIsValid()) {
				this.currDap.chantier.coordGeo = this.coordGeo;
			}
			this.currDap.coordGeoFromLieu = this.lieuCoordIsValid();

			if (this.currDap.id) {
				try {
					await this.updateMassiaDap(this.currDap);
					this.notification.success('DAP enregistrée avec succès');
					this.$onInit();
				} catch (error) {
					console.log(error);
				}
			} else {
				try {
					id = await this.createMassiaDap(this.currDap);
					if (id) {
						this.notification.success('DAP créée avec succès');
						this.$state.go('daps.edit', { id: id });
					}
				} catch (error) {
					console.log('🚀 ~ DapValidateFormController ~ save ~ error:', error);
					if (error.data) this.notification.error(error.data);
				}
			}
		}
		this.loading = false;
	}

	async saveAndClose() {
		if (this.validate()) {
			await this.save();
			this.annuler();
		}
	}

	async openValidationModal(isRefus) {
		this.$uibModal.open({
			animation: true,
			size: 's',
			component: 'dapValidationModal',
			resolve: {
				dap: () => this.currDap,
				isRefus: () => isRefus
			},
			controllerAs: '$ctrl'
		});
	}

	annuler() {
		this.$state.go('daps.list');
	}
	getSignatureStates() {
		console.log(this.currDap);

		this.showValidIcon =
			this.currDap.isSignatureClient &&
			this.currDap.transporteurs.every((t) => t.isSignature) &&
			((!this.isProducteurDemandeur && this.currDap.producteur !== null && this.currDap.isSignatureProducteurDechet) ||
				(this.isProducteurDemandeur && true));
	}

	/**
	 * Enregistre la Dap dans l'historique pour les "aller/retour" formulaire
	 */
	saveDapHistoryRoute() {
		this.historyService.dap = this.currDap;
		this.fromExternalForm = true;
	}

	async print() {
		if (this.portailAcces) {
			this.openModal();
		} else {
			const { data } = await this.DAPsService.print(this.currDap.id);
			try {
				const blob = new Blob([data], { type: 'application/pdf' });
				const url = window.URL.createObjectURL(blob);
				window.open(url, '_blank');
			} catch (ex) {
				console.error(ex);
			}
		}
	}

	async openModal() {
		try {
			this.ModalService.open({
				component: 'dapPrintModal',
				animation: true,
				size: 'md',
				resolve: {
					dap: () => this.currDap,
					dapDocSetting: () => this.dapDocSetting
				}
			});
		} catch (error) {
			console.error(error);
		}
	}

	onTicketLoaded(tickets) {
		this.tickets = tickets;
		this.currDap.dechets.forEach((dechet) => {
			const ticketsNomenclature = tickets.filter((ticket) => ticket.nomenclatureId === dechet.id);
			const totalNet = ticketsNomenclature.reduce((total, ticket) => total + ticket.net, 0);
			dechet.quantiteLivree = Math.round(totalNet * 100) / 100;
		});
	}
}
